import script from "./BannerView.vue?vue&type=script&setup=true&lang=ts"
export * from "./BannerView.vue?vue&type=script&setup=true&lang=ts"

import "./BannerView.vue?vue&type=style&index=0&id=479976c4&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/Shita-erp-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-479976c4"]])

export default __exports__